import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PMPatientADItemJSON } from '../common/models/server-response/pm-patient-ad-item-json.model';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { PMPatientListItemJSON } from '../common/models/server-response/pm-patient-list-item-json.model';
import { PMShopItemJSON } from '../common/models/server-response/pm-shop-item-json.model';
import { CodeSettings } from '../common/models/internal/code-settings';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';

@Injectable({
  providedIn: 'root'
})
export class PMRequestsService {

  constructor(private apiService: ApiService) { }

  getPatientsAD(country: CountryId): Observable<PMPatientADItemJSON[]>
  {
    const params = new HttpParams().set('countryId', country);
    return this.apiService.get(`/api/v1/wr/patientadmin/getCountryPatients`, params);
  }
  
  getPatientList(country: CountryId,limit:number,offset:number): Observable<PMPatientListItemJSON[]>
  {
    const params = new HttpParams().set('countryId', country).set('limit', limit).set('offset', offset);
    return this.apiService.get(`/api/v1/wr/patientadmin/getCountryShortSummaries`, params);
  }
  
  getShopsInfo(country: CountryId): Observable<PMShopItemJSON[]>
  {
    const params = new HttpParams().set('countryId', country);
    return this.apiService.get(`/api/v1/wr/admin/shops`, params);
  }
  
  
  resetPatientPassword(patientId: string): Observable<any>
  {
    const params = new HttpParams().set('patientId', patientId);
    return this.apiService.post(`/api/v1/wr/patientadmin/sendPasswordResetLink`,{}, params);
  }
  
  deletePatient(patientId: string): Observable<any>
  {
    const params = new HttpParams().set('patientId', patientId);
    return this.apiService.post(`/api/v1/wr/patientadmin/sendPatientDeleteRequest`,{}, params);
  }
  
  transferPatientToCLinic(patientId: string,shopId: string): Observable<any>
  {
    const params = new HttpParams().set('patientId', patientId).set('shopId', shopId);
    return this.apiService.post(`/api/v1/wr/patientadmin/patientMoveToShop`,{}, params);
  }
  
  getPendingDeletionPatients(): Observable<string[]>
  {
    return this.apiService.get(`/api/v1/wr/patientadmin/getActiveDeletionRequestPatientIds`);
  }

  generateReleaseCodes(settings:CodeSettings): Observable<any>
  {
       return this.apiService.postWithBlobResponse(`/api/v1/wr/qrcode/admin/qrcodes`,settings);
  }
}
